var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 31,
    viewBox: "0 0 62 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.710364 16.73C0.711093 16.7307 0.711695 16.7315 0.712546 16.7323L13.3673 29.326C14.3154 30.2695 15.8488 30.2659 16.7925 29.3178C17.736 28.3697 17.7324 26.8363 16.7843 25.8928L8.28792 17.4375L59.5781 17.4375C60.9157 17.4375 62 16.3532 62 15.0156C62 13.678 60.9157 12.5938 59.5781 12.5938L8.28804 12.5938L16.7842 4.13853C17.7323 3.19496 17.7359 1.66155 16.7923 0.713513C15.8486 -0.234773 14.3151 -0.238041 13.3672 0.705279L0.712424 13.299C0.711695 13.2998 0.711089 13.3006 0.710242 13.3013C-0.238283 14.248 -0.235257 15.7864 0.710364 16.73Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.4f99517ee38a6575d35e7d4c27fdfea5.svg";
export { ForwardRef as ReactComponent };